import parseHTML from "../dom/funciones/parse_html";
var SwipeIt = require('../swipe-it');
var cabecera = function () {
    [].forEach.call(document.querySelectorAll('.cabecera__slides'), function (el) {
        var activa = 0;
        var slides = [].slice.call(el.querySelectorAll('.cabecera__slide'));
        if (slides.length < 2) {
            return;
        }
        var contenedorBotones = parseHTML('<div class="cabecera__botones"></div>');
        var botones = slides.map(function (slide, i) {
            var boton = parseHTML("<button class=\"cabecera__boton\" data-slide=\"".concat(i, "\">").concat(i + 1, "</button>"));
            contenedorBotones.appendChild(boton);
            return boton;
        });
        var cambiarSlide = function (nuevo) {
            slides[activa].setAttribute('aria-hidden', 'true');
            slides[nuevo].setAttribute('aria-hidden', 'false');
            botones[activa].setAttribute('aria-selected', 'false');
            botones[nuevo].setAttribute('aria-selected', 'true');
            activa = nuevo;
        };
        botones.forEach(function (boton, i) {
            boton.addEventListener('click', function () { return cambiarSlide(i); });
        });
        cambiarSlide(0);
        var swipeIt = new SwipeIt(el);
        swipeIt.on('swipeLeft', function () { return cambiarSlide((activa + 1) % slides.length); });
        swipeIt.on('swipeRight', function () { return cambiarSlide((activa - 1 + slides.length) % slides.length); });
        el.appendChild(contenedorBotones);
    });
};
export default cabecera;
